import axios from "axios";
import Config from "../../utils/Config";
const baseUrl = Config.baseUrl;

class SmsRequests {
  getHeaders() {
    const token = localStorage.getItem("txtconnect_ng_user_token");
    //console.log("Auth token:", token ? "Present" : "Missing");

    return {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };
  }

  // Helper: Clean a single phone number
  cleanNumber(number) {
    return number.replace(/\s/g, "").replace(/\D/g, "");
  }

  // Helper: Clean arrays of phone numbers
  cleanNumbersArray(numbers) {
    return numbers.map((num) => this.cleanNumber(num));
  }

  // ------------------------------------------
  // Todo => Send Quick SMS
  // ------------------------------------------
  async sendQuickSms(data) {
    //console.log("sendQuickSms called with data:", data);
    //console.log("baseUrl:", baseUrl);
    //console.log("headers:", this.getHeaders());

    try {
      // Clean phone numbers properly (ARRAY, not string)
      const cleanedRecipients = this.cleanNumbersArray(data.recipients);

      const requestPayload = {
        msisdns: cleanedRecipients, // FIXED: must be ARRAY
        content: data.message,
        sender_id: data.sender_id,
      };

      console.log(
        "Making axios POST request to:",
        `${baseUrl}api/user/send/quick/sms`
      );
      console.log("Request payload:", requestPayload);

      const response = await axios.post(
        `${baseUrl}api/user/send/quick/sms`,
        requestPayload,
        {
          headers: this.getHeaders(),
        }
      );

      //console.log("API call successful:", response.data);

      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      console.error("sendQuickSms error:", error);
      console.error("Error response:", error.response);
      console.error("Error message:", error.message);

      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // ------------------------------------------
  // Todo => Send Bulk SMS
  // ------------------------------------------
  async sendBulkSms(data) {
    try {
      const cleanedData = {
        ...data,

        // Clean recipients if present
        ...(data.recipients && {
          recipients: this.cleanNumbersArray(data.recipients),
        }),

        // Clean msisdns if present
        ...(data.msisdns && {
          msisdns: this.cleanNumbersArray(data.msisdns),
        }),
      };

      const response = await axios.post(
        `${baseUrl}api/user/send/bulk/sms`,
        cleanedData,
        {
          headers: this.getHeaders(),
        }
      );

      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // ------------------------------------------
  // Get SMS History
  // ------------------------------------------
  async getSmsHistory(page = 1, limit = 10) {
    try {
      const response = await axios.get(
        `${baseUrl}api/user/sms-history?page=${page}&limit=${limit}`,
        {
          headers: this.getHeaders(),
        }
      );

      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }

  // ------------------------------------------
  // Get SMS Statistics
  // ------------------------------------------
  async getSmsStats() {
    try {
      const response = await axios.get(`${baseUrl}api/user/sms-stats`, {
        headers: this.getHeaders(),
      });

      return {
        success: true,
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data || error.message,
        status: error.response?.status || 500,
      };
    }
  }
}

const smsRequests = new SmsRequests();
export default smsRequests;
